import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

const styles = (theme: Theme) =>
  createStyles({
    root: {
      flex: 1,
      display: 'flex',
      alignItems: 'center',
      padding: '20px 0',
      color: theme.oysterTheme.ferrari,
      '& .MuiSvgIcon-root': {
        marginRight: 10,
      },
    },
  });

export default makeStyles(styles);
